import type { SubscribeStepProps } from "../Subscribe.controller";
import { SelectPlanPresentation } from "./SelectPlan.pres";

export const SelectPlanConnector = ({
  isElite,
  paymentSchedule,
  onPaymentScheduleChange,
  onContinueToNextStep,
  plans,
}: SubscribeStepProps) => {
  return (
    <SelectPlanPresentation
      isElite={isElite}
      paymentSchedule={paymentSchedule}
      onPaymentScheduleChange={onPaymentScheduleChange}
      onContinue={onContinueToNextStep}
      plans={plans}
    />
  );
};
